import type { TFunction } from 'i18next';
import type { BookingStatus, CalendarProvider } from '../types';

export const BOOKING_STATUSES: BookingStatus[] = ['REQUESTED', 'CONFIRMED', 'CANCELLED'];

export function getLanguageTag(language?: string): string {
  return language?.startsWith('ar') ? 'ar-SA' : 'en-US';
}

export function getCalendarProviderLabel(t: TFunction, provider: CalendarProvider): string {
  switch (provider) {
    case 'GOOGLE':
      return t('booking.providers.google');
    case 'OUTLOOK':
      return t('booking.providers.outlook');
    case 'ICS':
      return t('booking.providers.ics');
  }
}

export function getBookingStatusLabel(t: TFunction, status: BookingStatus): string {
  switch (status) {
    case 'REQUESTED':
      return t('booking.status.requested');
    case 'CONFIRMED':
      return t('booking.status.confirmed');
    case 'CANCELLED':
      return t('booking.status.cancelled');
  }
}

export function formatBookingDateTimeRange(startAt: string, endAt: string, language?: string): string {
  const locale = getLanguageTag(language);
  const start = new Date(startAt);
  const end = new Date(endAt);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return '-';
  }

  const sameDay = start.toDateString() === end.toDateString();

  if (sameDay) {
    return `${start.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })} • ${start.toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: '2-digit',
    })} - ${end.toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: '2-digit',
    })}`;
  }

  return `${start.toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })} - ${end.toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })}`;
}
